import {ProductionDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_AGGREGATED_CALENDAR_PRODUCTION_BY_DAY';

export async function getAggregatedCalendarProductionsByDay(
    userData: Record<string, string>,
    before: string,
    after: string,
    query?: string
) {
    try {
        const result = await ProductionDao.getAggregatedCalendarProductionsByDay(userData, before, after, query);

        const metadata = {
            count: result.count,
            next: result.next,
            previous: result.previous
        };

        return {
            metadata,
            data: result
        };
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
